import React from "react";
import Select from "react-select";
import i18n, { LANGUAGES, normalizeLanguage } from "../../i18n";

// "Preferred Language for Communications": the ONE language a client / medium wants
// us to communicate in. Stored as a code in users.preferred_communication_language.
// Same four languages as the site's language dropdown.
export const PREFERRED_LANGUAGE_CODES = ["en", "fr", "es", "de"];

export const PREFERRED_LANGUAGE_OPTIONS = PREFERRED_LANGUAGE_CODES.map((code) => {
  const meta = LANGUAGES.find((l) => l.code === code) || { label: code };
  return { value: code, label: meta.label };
});

// Default for an empty field: the language the site is shown in right now
// (they just picked it), otherwise English.
export const defaultPreferredLanguage = () => {
  const current = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
  return PREFERRED_LANGUAGE_CODES.includes(current) ? current : "en";
};

// Value from the API (code, or null for users who never set it) -> form value.
export const preferredLanguageOrDefault = (value) =>
  PREFERRED_LANGUAGE_CODES.includes(value) ? value : defaultPreferredLanguage();

// Single-select dropdown. `value` / `onChange` work with the code ("fr").
export default function PreferredLanguageSelect({ id = "preferred_communication_language", value, onChange, onBlur, placeholder, className = "selection-box", isDisabled = false }) {
  const selected = PREFERRED_LANGUAGE_OPTIONS.find((o) => o.value === value) || null;
  return (
    <Select
      id={id}
      name={id}
      className={className}
      options={PREFERRED_LANGUAGE_OPTIONS}
      isMulti={false}
      isSearchable={false}
      isDisabled={isDisabled}
      value={selected}
      onChange={(option) => onChange(option ? option.value : "")}
      onBlur={onBlur}
      placeholder={placeholder}
    />
  );
}
